export const paisesOptions = [
    { key: 'af', value: 'af', flag: 'af', text: 'Afganistán' },
    { key: 'al', value: 'al', flag: 'al', text: 'Albania' },
    { key: 'de', value: 'de', flag: 'de', text: 'Alemania' },
    { key: 'dz', value: 'dz', flag: 'dz', text: 'Algeria' },
    { key: 'ad', value: 'ad', flag: 'ad', text: 'Andorra' },
    { key: 'ao', value: 'ao', flag: 'ao', text: 'Angola' },
    { key: 'ai', value: 'ai', flag: 'ai', text: 'Anguila' },
    { key: 'aq', value: 'aq', text: 'Antártida' },
    { key: 'ag', value: 'ag', flag: 'ag', text: 'Antigua y Barbuda' },
    { key: 'an', value: 'an', flag: 'an', text: 'Antillas Neerlandesas' },
    { key: 'sa', value: 'sa', flag: 'sa', text: 'Arabia Saudita' },
    { key: 'ar', value: 'ar', flag: 'ar', text: 'Argentina' },
    { key: 'am', value: 'am', flag: 'am', text: 'Armenia' },
    { key: 'aw', value: 'aw', flag: 'aw', text: 'Aruba' },
    { key: 'au', value: 'au', flag: 'au', text: 'Australia' },
    { key: 'at', value: 'at', flag: 'at', text: 'Austria' },
    { key: 'az', value: 'az', flag: 'az', text: 'Azerbayán' },
    { key: 'be', value: 'be', flag: 'be', text: 'Bélgica' },
    { key: 'bs', value: 'bs', flag: 'bs', text: 'Bahamas' },
    { key: 'bh', value: 'bh', flag: 'bh', text: 'Bahrein' },
    { key: 'bd', value: 'bd', flag: 'bd', text: 'Bangladesh' },
    { key: 'bb', value: 'bb', flag: 'bb', text: 'Barbados' },
    { key: 'bz', value: 'bz', flag: 'bz', text: 'Belice' },
    { key: 'bj', value: 'bj', flag: 'bj', text: 'Benín' },
    { key: 'bt', value: 'bt', flag: 'bt', text: 'Bhután' },
    { key: 'by', value: 'by', flag: 'by', text: 'Bielorrusia' },
    { key: 'mm', value: 'mm', flag: 'mm', text: 'Birmania' },
    { key: 'bo', value: 'bo', flag: 'bo', text: 'Bolivia' },
    { key: 'ba', value: 'ba', flag: 'ba', text: 'Bosnia y Herzegovina' },
    { key: 'bw', value: 'bw', flag: 'bw', text: 'Botsuana' },
    { key: 'br', value: 'br', flag: 'br', text: 'Brasil' },
    { key: 'bn', value: 'bn', flag: 'bn', text: 'Brunéi' },
    { key: 'bg', value: 'bg', flag: 'bg', text: 'Bulgaria' },
    { key: 'bf', value: 'bf', flag: 'bf', text: 'Burkina Faso' },
    { key: 'bi', value: 'bi', flag: 'bi', text: 'Burundi' },
    { key: 'cv', value: 'cv', flag: 'cv', text: 'Cabo Verde' },
    { key: 'kh', value: 'kh', flag: 'kh', text: 'Camboya' },
    { key: 'cm', value: 'cm', flag: 'cm', text: 'Camerún' },
    { key: 'ca', value: 'ca', flag: 'ca', text: 'Canadá' },
    { key: 'td', value: 'td', flag: 'td', text: 'Chad' },
    { key: 'cl', value: 'cl', flag: 'cl', text: 'Chile' },
    { key: 'cn', value: 'cn', flag: 'cn', text: 'China' },
    { key: 'cy', value: 'cy', flag: 'cy', text: 'Chipre' },
    { key: 'va', value: 'va', flag: 'va', text: 'Ciudad del Vaticano' },
    { key: 'co', value: 'co', flag: 'co', text: 'Colombia' },
    { key: 'km', value: 'km', flag: 'km', text: 'Comoras' },
    { key: 'cg', value: 'cg', flag: 'cg', text: 'Congo' },
    { key: 'cd', value: 'cd', flag: 'cd', text: 'Congo' },
    { key: 'kp', value: 'kp', flag: 'kp', text: 'Corea del Norte' },
    { key: 'kr', value: 'kr', flag: 'kr', text: 'Corea del Sur' },
    { key: 'ci', value: 'ci', flag: 'ci', text: 'Costa de Marfil' },
    { key: 'cr', value: 'cr', flag: 'cr', text: 'Costa Rica' },
    { key: 'hr', value: 'hr', flag: 'hr', text: 'Croacia' },
    { key: 'cu', value: 'cu', flag: 'cu', text: 'Cuba' },
    { key: 'dk', value: 'dk', flag: 'dk', text: 'Dinamarca' },
    { key: 'dm', value: 'dm', flag: 'dm', text: 'Dominica' },
    { key: 'ec', value: 'ec', flag: 'ec', text: 'Ecuador' },
    { key: 'eg', value: 'eg', flag: 'eg', text: 'Egipto' },
    { key: 'sv', value: 'sv', flag: 'sv', text: 'El Salvador' },
    { key: 'ae', value: 'ae', flag: 'ae', text: 'Emiratos Árabes Unidos' },
    { key: 'er', value: 'er', flag: 'er', text: 'Eritrea' },
    { key: 'sk', value: 'sk', flag: 'sk', text: 'Eslovaquia' },
    { key: 'si', value: 'si', flag: 'si', text: 'Eslovenia' },
    { key: 'es', value: 'es', flag: 'es', text: 'España' },
    { key: 'us', value: 'us', flag: 'us', text: 'Estados Unidos de América' },
    { key: 'ee', value: 'ee', flag: 'ee', text: 'Estonia' },
    { key: 'et', value: 'et', flag: 'et', text: 'Etiopía' },
    { key: 'ph', value: 'ph', flag: 'ph', text: 'Filipinas' },
    { key: 'fi', value: 'fi', flag: 'fi', text: 'Finlandia' },
    { key: 'fj', value: 'fj', flag: 'fj', text: 'Fiyi' },
    { key: 'fr', value: 'fr', flag: 'fr', text: 'Francia' },
    { key: 'ga', value: 'ga', flag: 'ga', text: 'Gabón' },
    { key: 'gm', value: 'gm', flag: 'gm', text: 'Gambia' },
    { key: 'ge', value: 'ge', flag: 'ge', text: 'Georgia' },
    { key: 'gh', value: 'gh', flag: 'gh', text: 'Ghana' },
    { key: 'gi', value: 'gi', flag: 'gi', text: 'Gibraltar' },
    { key: 'gd', value: 'gd', flag: 'gd', text: 'Granada' },
    { key: 'gr', value: 'gr', flag: 'gr', text: 'Grecia' },
    { key: 'gl', value: 'gl', flag: 'gl', text: 'Groenlandia' },
    { key: 'gp', value: 'gp', flag: 'gp', text: 'Guadalupe' },
    { key: 'gu', value: 'gu', flag: 'gu', text: 'Guam' },
    { key: 'gt', value: 'gt', flag: 'gt', text: 'Guatemala' },
    { key: 'gf', value: 'gf', flag: 'gf', text: 'Guayana Francesa' },
    { key: 'gg', value: 'gg', text: 'Guernsey' },
    { key: 'gn', value: 'gn', flag: 'gn', text: 'Guinea' },
    { key: 'gq', value: 'gq', flag: 'gq', text: 'Guinea Ecuatorial' },
    { key: 'gw', value: 'gw', flag: 'gw', text: 'Guinea-Bissau' },
    { key: 'gy', value: 'gy', flag: 'gy', text: 'Guyana' },
    { key: 'ht', value: 'ht', flag: 'ht', text: 'Haití' },
    { key: 'hn', value: 'hn', flag: 'hn', text: 'Honduras' },
    { key: 'hk', value: 'hk', flag: 'hk', text: 'Hong kong' },
    { key: 'hu', value: 'hu', flag: 'hu', text: 'Hungría' },
    { key: 'in', value: 'in', flag: 'in', text: 'India' },
    { key: 'id', value: 'id', flag: 'id', text: 'Indonesia' },
    { key: 'ir', value: 'ir', flag: 'ir', text: 'Irán' },
    { key: 'iq', value: 'iq', flag: 'iq', text: 'Irak' },
    { key: 'ie', value: 'ie', flag: 'ie', text: 'Irlanda' },
    { key: 'bv', value: 'bv', flag: 'bv', text: 'Isla Bouvet' },
    { key: 'im', value: 'im', text: 'Isla de Man' },
    { key: 'cx', value: 'cx', flag: 'cx', text: 'Isla de Navidad' },
    { key: 'nf', value: 'nf', flag: 'nf', text: 'Isla Norfolk' },
    { key: 'is', value: 'is', flag: 'is', text: 'Islandia' },
    { key: 'bm', value: 'bm', flag: 'bm', text: 'Islas Bermudas' },
    { key: 'ky', value: 'ky', flag: 'ky', text: 'Islas Caimán' },
    { key: 'cc', value: 'cc', flag: 'cc', text: 'Islas Cocos (Keeling)' },
    { key: 'ck', value: 'ck', flag: 'ck', text: 'Islas Cook' },
    { key: 'ax', value: 'ax', flag: 'ax', text: 'Islas de Åland' },
    { key: 'fo', value: 'fo', flag: 'fo', text: 'Islas Feroe' },
    { key: 'gs', value: 'gs', flag: 'gs', text: 'Islas Georgias del Sur y Sandwich del Sur' },
    { key: 'hm', value: 'hm', flag: 'hm', text: 'Islas Heard y McDonald' },
    { key: 'mv', value: 'mv', flag: 'mv', text: 'Islas Maldivas' },
    { key: 'fk', value: 'fk', flag: 'fk', text: 'Islas Malvinas' },
    { key: 'mp', value: 'mp', flag: 'mp', text: 'Islas Marianas del Norte' },
    { key: 'mh', value: 'mh', flag: 'mh', text: 'Islas Marshall' },
    { key: 'pn', value: 'pn', flag: 'pn', text: 'Islas Pitcairn' },
    { key: 'sb', value: 'sb', flag: 'sb', text: 'Islas Salomón' },
    { key: 'tc', value: 'tc', flag: 'tc', text: 'Islas Turcas y Caicos' },
    { key: 'um', value: 'um', flag: 'um', text: 'Islas Ultramarinas Menores de Estados Unidos' },
    { key: 'vg', value: 'vg', flag: 'vg', text: 'Islas Vírgenes Británicas' },
    { key: 'vi', value: 'vi', flag: 'vi', text: 'Islas Vírgenes de los Estados Unidos' },
    { key: 'il', value: 'il', flag: 'il', text: 'Israel' },
    { key: 'it', value: 'it', flag: 'it', text: 'Italia' },
    { key: 'jm', value: 'jm', flag: 'jm', text: 'Jamaica' },
    { key: 'jp', value: 'jp', flag: 'jp', text: 'Japón' },
    { key: 'je', value: 'je', text: 'Jersey' },
    { key: 'jo', value: 'jo', flag: 'jo', text: 'Jordania' },
    { key: 'kz', value: 'kz', flag: 'kz', text: 'Kazajistán' },
    { key: 'ke', value: 'ke', flag: 'ke', text: 'Kenia' },
    { key: 'kg', value: 'kg', flag: 'kg', text: 'Kirgizstán' },
    { key: 'ki', value: 'ki', flag: 'ki', text: 'Kiribati' },
    { key: 'kw', value: 'kw', flag: 'kw', text: 'Kuwait' },
    { key: 'lb', value: 'lb', flag: 'lb', text: 'Líbano' },
    { key: 'la', value: 'la', flag: 'la', text: 'Laos' },
    { key: 'ls', value: 'ls', flag: 'ls', text: 'Lesoto' },
    { key: 'lv', value: 'lv', flag: 'lv', text: 'Letonia' },
    { key: 'lr', value: 'lr', flag: 'lr', text: 'Liberia' },
    { key: 'ly', value: 'ly', flag: 'ly', text: 'Libia' },
    { key: 'li', value: 'li', flag: 'li', text: 'Liechtenstein' },
    { key: 'lt', value: 'lt', flag: 'lt', text: 'Lituania' },
    { key: 'lu', value: 'lu', flag: 'lu', text: 'Luxemburgo' },
    { key: 'mx', value: 'mx', flag: 'mx', text: 'México' },
    { key: 'mc', value: 'mc', flag: 'mc', text: 'Mónaco' },
    { key: 'mo', value: 'mo', flag: 'mo', text: 'Macao' },
    { key: 'mk', value: 'mk', flag: 'mk', text: 'Macedônia' },
    { key: 'mg', value: 'mg', flag: 'mg', text: 'Madagascar' },
    { key: 'my', value: 'my', flag: 'my', text: 'Malasia' },
    { key: 'mw', value: 'mw', flag: 'mw', text: 'Malawi' },
    { key: 'ml', value: 'ml', flag: 'ml', text: 'Mali' },
    { key: 'mt', value: 'mt', flag: 'mt', text: 'Malta' },
    { key: 'ma', value: 'ma', flag: 'ma', text: 'Marruecos' },
    { key: 'mq', value: 'mq', flag: 'mq', text: 'Martinica' },
    { key: 'mu', value: 'mu', flag: 'mu', text: 'Mauricio' },
    { key: 'mr', value: 'mr', flag: 'mr', text: 'Mauritania' },
    { key: 'yt', value: 'yt', flag: 'yt', text: 'Mayotte' },
    { key: 'fm', value: 'fm', flag: 'fm', text: 'Micronesia' },
    { key: 'md', value: 'md', flag: 'md', text: 'Moldavia' },
    { key: 'mn', value: 'mn', flag: 'mn', text: 'Mongolia' },
    { key: 'me', value: 'me', flag: 'me', text: 'Montenegro' },
    { key: 'ms', value: 'ms', flag: 'ms', text: 'Montserrat' },
    { key: 'mz', value: 'mz', flag: 'mz', text: 'Mozambique' },
    { key: 'na', value: 'na', flag: 'na', text: 'Namibia' },
    { key: 'nr', value: 'nr', flag: 'nr', text: 'Nauru' },
    { key: 'np', value: 'np', flag: 'np', text: 'Nepal' },
    { key: 'ni', value: 'ni', flag: 'ni', text: 'Nicaragua' },
    { key: 'ne', value: 'ne', flag: 'ne', text: 'Niger' },
    { key: 'ng', value: 'ng', flag: 'ng', text: 'Nigeria' },
    { key: 'nu', value: 'nu', flag: 'nu', text: 'Niue' },
    { key: 'no', value: 'no', flag: 'no', text: 'Noruega' },
    { key: 'nc', value: 'nc', flag: 'nc', text: 'Nueva Caledonia' },
    { key: 'nz', value: 'nz', flag: 'nz', text: 'Nueva Zelanda' },
    { key: 'om', value: 'om', flag: 'om', text: 'Omán' },
    { key: 'nl', value: 'nl', flag: 'nl', text: 'Países Bajos' },
    { key: 'pk', value: 'pk', flag: 'pk', text: 'Pakistán' },
    { key: 'pw', value: 'pw', flag: 'pw', text: 'Palau' },
    { key: 'ps', value: 'ps', flag: 'ps', text: 'Palestina' },
    { key: 'pa', value: 'pa', flag: 'pa', text: 'Panamá' },
    { key: 'pg', value: 'pg', flag: 'pg', text: 'Papúa Nueva Guinea' },
    { key: 'py', value: 'py', flag: 'py', text: 'Paraguay' },
    { key: 'pe', value: 'pe', flag: 'pe', text: 'Perú' },
    { key: 'pf', value: 'pf', flag: 'pf', text: 'Polinesia Francesa' },
    { key: 'pl', value: 'pl', flag: 'pl', text: 'Polonia' },
    { key: 'pt', value: 'pt', flag: 'pt', text: 'Portugal' },
    { key: 'pr', value: 'pr', flag: 'pr', text: 'Puerto Rico' },
    { key: 'qa', value: 'qa', flag: 'qa', text: 'Qatar' },
    { key: 'gb', value: 'gb', flag: 'gb', text: 'Reino Unido' },
    { key: 'cf', value: 'cf', flag: 'cf', text: 'República Centroafricana' },
    { key: 'cz', value: 'cz', flag: 'cz', text: 'República Checa' },
    { key: 'do', value: 'do', flag: 'do', text: 'República Dominicana' },
    { key: 're', value: 're', flag: 're', text: 'Reunión' },
    { key: 'rw', value: 'rw', flag: 'rw', text: 'Ruanda' },
    { key: 'ro', value: 'ro', flag: 'ro', text: 'Rumanía' },
    { key: 'ru', value: 'ru', flag: 'ru', text: 'Rusia' },
    { key: 'eh', value: 'eh', flag: 'eh', text: 'Sahara Occidental' },
    { key: 'ws', value: 'ws', flag: 'ws', text: 'Samoa' },
    { key: 'as', value: 'as', flag: 'as', text: 'Samoa Americana' },
    { key: 'bl', value: 'bl', text: 'San Bartolomé' },
    { key: 'kn', value: 'kn', flag: 'kn', text: 'San Cristóbal y Nieves' },
    { key: 'sm', value: 'sm', flag: 'sm', text: 'San Marino' },
    { key: 'mf', value: 'mf', text: 'San Martín (Francia)' },
    { key: 'pm', value: 'pm', flag: 'pm', text: 'San Pedro y Miquelón' },
    { key: 'vc', value: 'vc', flag: 'vc', text: 'San Vicente y las Granadinas' },
    { key: 'sh', value: 'sh', flag: 'sh', text: 'Santa Elena' },
    { key: 'lc', value: 'lc', flag: 'lc', text: 'Santa Lucía' },
    { key: 'st', value: 'st', flag: 'st', text: 'Santo Tomé y Príncipe' },
    { key: 'sn', value: 'sn', flag: 'sn', text: 'Senegal' },
    { key: 'rs', value: 'rs', flag: 'rs', text: 'Serbia' },
    { key: 'sc', value: 'sc', flag: 'sc', text: 'Seychelles' },
    { key: 'sl', value: 'sl', flag: 'sl', text: 'Sierra Leona' },
    { key: 'sg', value: 'sg', flag: 'sg', text: 'Singapur' },
    { key: 'sy', value: 'sy', flag: 'sy', text: 'Siria' },
    { key: 'so', value: 'so', flag: 'so', text: 'Somalia' },
    { key: 'lk', value: 'lk', flag: 'lk', text: 'Sri lanka' },
    { key: 'za', value: 'za', flag: 'za', text: 'Sudáfrica' },
    { key: 'sd', value: 'sd', flag: 'sd', text: 'Sudán' },
    { key: 'se', value: 'se', flag: 'se', text: 'Suecia' },
    { key: 'ch', value: 'ch', flag: 'ch', text: 'Suiza' },
    { key: 'sr', value: 'sr', flag: 'sr', text: 'Surinám' },
    { key: 'sj', value: 'sj', flag: 'sj', text: 'Svalbard y Jan Mayen' },
    { key: 'sz', value: 'sz', flag: 'sz', text: 'Swazilandia' },
    { key: 'tj', value: 'tj', flag: 'tj', text: 'Tadjikistán' },
    { key: 'th', value: 'th', flag: 'th', text: 'Tailandia' },
    { key: 'tw', value: 'tw', flag: 'tw', text: 'Taiwán' },
    { key: 'tz', value: 'tz', flag: 'tz', text: 'Tanzania' },
    { key: 'io', value: 'io', flag: 'io', text: 'Territorio Británico del Océano Índico' },
    { key: 'tf', value: 'tf', flag: 'tf', text: 'Territorios Australes y Antárticas Franceses' },
    { key: 'tl', value: 'tl', flag: 'tl', text: 'Timor Oriental' },
    { key: 'tg', value: 'tg', flag: 'tg', text: 'Togo' },
    { key: 'tk', value: 'tk', flag: 'tk', text: 'Tokelau' },
    { key: 'to', value: 'to', flag: 'to', text: 'Tonga' },
    { key: 'tt', value: 'tt', flag: 'tt', text: 'Trinidad y Tobago' },
    { key: 'tn', value: 'tn', flag: 'tn', text: 'Tunez' },
    { key: 'tm', value: 'tm', flag: 'tm', text: 'Turkmenistán' },
    { key: 'tr', value: 'tr', flag: 'tr', text: 'Turquía' },
    { key: 'tv', value: 'tv', flag: 'tv', text: 'Tuvalu' },
    { key: 'ua', value: 'ua', flag: 'ua', text: 'Ucrania' },
    { key: 'ug', value: 'ug', flag: 'ug', text: 'Uganda' },
    { key: 'uy', value: 'uy', flag: 'uy', text: 'Uruguay' },
    { key: 'uz', value: 'uz', flag: 'uz', text: 'Uzbekistán' },
    { key: 'vu', value: 'vu', flag: 'vu', text: 'Vanuatu' },
    { key: 've', value: 've', flag: 've', text: 'Venezuela' },
    { key: 'vn', value: 'vn', flag: 'vn', text: 'Vietnam' },
    { key: 'wf', value: 'wf', flag: 'wf', text: 'Wallis y Futuna' },
    { key: 'ye', value: 'ye', flag: 'ye', text: 'Yemen' },
    { key: 'dj', value: 'dj', flag: 'dj', text: 'Yibuti' },
    { key: 'zm', value: 'zm', flag: 'zm', text: 'Zambia' },
    { key: 'zw', value: 'zw', flag: 'zw', text: 'Zimbabue' },
];

export default paisesOptions;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/RutPasaporte/componentes/Pasaporte/paisesOptions.ts